'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.default = void 0;

var _jsxRuntime = require('react/jsx-runtime');

var _propTypes = _interopRequireDefault(require('prop-types'));

var _styles = require('@material-ui/core/styles');

var _core = require('@material-ui/core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === 'undefined' || !(Symbol.iterator in Object(arr)))
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (
      var _i = arr[Symbol.iterator](), _s;
      !(_n = (_s = _i.next()).done);
      _n = true
    ) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/**
 * This component is to wrap a image inside a fixed ratio wrapper
 * The image will be scaled and centered either vetically or horizontally if its size exceeds the wrapper
 *
 * @example
 *
 *  const Demo = () => (
 *    <ImageWrapper ratio="4:3" src='https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_960_720.jpg' atl="demo"/>
 *  );
 *
 * @typedef {Object} Props
 * @prop {string} src The `src` attribute of the wrapped `img`
 * @prop {string} alt The `alt` attribute of the wrapped `img`
 *
 * @param {Prop} props
 */
var calculatePaddingTop = function calculatePaddingTop(ratio) {
  var _ratio$split = ratio.split(':'),
    _ratio$split2 = _slicedToArray(_ratio$split, 2),
    width = _ratio$split2[0],
    height = _ratio$split2[1];

  var paddingTop = (height / width) * 100;

  if (Number.isNaN(paddingTop)) {
    // Return the value for 16:9
    return '56.25%';
  }

  return ''.concat(paddingTop, '%');
};

var ImageWrapper = function ImageWrapper(_ref) {
  var src = _ref.src,
    alt = _ref.alt,
    ratio = _ref.ratio;
  var theme = (0, _styles.useTheme)();
  var classes = useStyles();
  return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Box, {
    paddingTop: calculatePaddingTop(ratio),
    position: 'relative',
    bgcolor: theme.palette.grey['200'],
    borderRadius: theme.shape.borderRadius,
    overflow: 'hidden',
    children:
      src &&
      /*#__PURE__*/ (0, _jsxRuntime.jsx)(_core.Box, {
        component: 'img',
        position: 'absolute',
        top: '50%',
        left: '50%',
        maxWidth: '100%',
        maxHeight: '100%',
        src: src,
        alt: alt,
        className: classes.img,
      }),
  });
};

var useStyles = (0, _styles.makeStyles)({
  img: {
    transform: 'translate(-50%, -50%)',
  },
});
ImageWrapper.propTypes = {
  /**
   * The `src` attribute of the wrapped `img`
   */
  src: _propTypes.default.string,

  /**
   * The `alt` attribute of the wrapped `img`
   */
  alt: _propTypes.default.string,

  /**
   * The ratio of the wrapper, must be in format `w:h` e.g. `4:3`
   * Default is `16:9`
   */
  ratio: _propTypes.default.string,
};
ImageWrapper.defaultProps = {
  ratio: '16:9',
};
var _default = ImageWrapper;
exports.default = _default;

//# sourceMappingURL=index.js.map
